// „Fester Wert“ im Mapping: Auswahlliste oder Freitext?
//
// OTTO liefert je Attribut allowedValues (feste Auswahl, z. B. Geschlecht) getrennt von
// exampleValues/recommendedValues (nur Beispiele, z. B. Materialzusammensetzung). Eine Auswahlliste
// gibt es nur für allowedValues bei Einzelwerten. Mehrfachwerte mit allowedValues bleiben bis auf
// Weiteres Freitext mit Vorschlägen, weil die Mehrfachwert-Speicherung noch nicht durchgereicht ist.

export interface FixedValueField {
  allowedValues?: string[];
  exampleValues?: string[];
  multiValue?: boolean;
}

export type FixedValueChoice =
  | { mode: 'select'; values: string[] }
  | { mode: 'suggest'; values: string[] }
  | { mode: 'free'; values: [] };

export function fixedValueChoice(f: FixedValueField): FixedValueChoice {
  const allowed = f.allowedValues ?? [];
  if (allowed.length > 0) return f.multiValue ? { mode: 'suggest', values: allowed } : { mode: 'select', values: allowed };
  const examples = f.exampleValues ?? [];
  if (examples.length > 0) return { mode: 'suggest', values: examples };
  return { mode: 'free', values: [] };
}
